import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import {FormBuilder, FormGroup, Validators, FormControl, FormArray, AbstractControl} from '@angular/forms';
import { PreciosService } from '../../../../services/precios-service';


@Component({
  selector: 'app-new-edit-mercado-dialog',
  templateUrl: './new-edit-mercado-dialog.component.html',
  styleUrls: ['./new-edit-mercado-dialog.component.scss']
})
export class NewEditMercadoDialogComponent implements OnInit {

  constructor(public dialogRef: MdDialogRef<NewEditMercadoDialogComponent>,
    private formBuilder: FormBuilder,
    private precioService: PreciosService) { }

  public mercado = null;
  public mercadoCodigos = [];

  private isEdit = false;
  title = '';

  form: FormGroup;

  ngOnInit() {
    console.log(this.mercado);
    this.isEdit = this.mercado !== null;
    this.title = this.isEdit ? 'Editar Mercado' : 'Nuevo Mercado';

    const nombre = this.isEdit ? this.mercado.Mercado : '';
    const codigo: number = this.isEdit ? this.mercado.Codigo : 0;

    const codigoControl: FormControl = new FormControl({value: codigo, disabled: this.isEdit});
    codigoControl.setValidators([Validators.required, existsInArrayNumber(this.mercadoCodigos), Validators.min(1), Validators.max(999)]);

    this.form = this.formBuilder.group({
      id: this.isEdit ? this.mercado.Id : 0,
      nombre: [nombre, [Validators.required]],
      codigo: codigoControl,
      visibilidad: this.isEdit ? this.mercado.Visibilidad : true
    });
  }

  onSubmit() {
    if (this.form.invalid) { return; }

    if (this.isEdit) {
      const payload = {
        Id: this.form.get('id').value,
        Mercado: this.nombre.value,
        Visibilidad: this.form.get('visibilidad').value,
        Codigo: this.codigo.value
      };

      this.precioService.editarMercado(payload).subscribe(res => {
        if (res) {
          this.dialogRef.close(true);
        }
      });

    } else {
      const payload = {
        Mercado: this.nombre.value,
        Visibilidad: true,
        Codigo: this.codigo.value,
      };

      this.precioService.crearMercado(payload).subscribe(res => {
        if (res) {
          this.dialogRef.close(true);
        }
      });
    }
  }

  get nombre() {
    return this.form.get('nombre');
  }

  get codigo() {
    return this.form.get('codigo');
  }

}

function existsInArrayNumber(values: number[]) {
  return (control: FormControl) => {
    return values.length ? values.indexOf(control.value) > -1 ? {existsInArrayNumber: true} : null : null;
  };
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/mercado/new-edit-mercado-dialog/new-edit-mercado-dialog.component.ts